import React, { useEffect, useRef, useState } from "react";
import { X, Volume2, VolumeX } from "lucide-react";
import { api } from "../services/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const SEEN_KEY = "ssuq_intro_seen";

const absUrl = (u) => (u && u.startsWith("/") ? `${BACKEND}${u}` : u);

const IntroSplash = () => {
  const [show, setShow] = useState(false);
  const [src, setSrc] = useState("");
  const [muted, setMuted] = useState(true);
  const videoRef = useRef(null);

  useEffect(() => {
    if (sessionStorage.getItem(SEEN_KEY)) return;
    let active = true;
    api
      .getIntro()
      .then((cfg) => {
        if (!active) return;
        if (cfg && cfg.enabled && cfg.videoUrl) {
          setSrc(absUrl(cfg.videoUrl));
          setShow(true);
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  const dismiss = () => {
    sessionStorage.setItem(SEEN_KEY, "1");
    setShow(false);
  };

  const toggleSound = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
    if (!v.muted) v.play().catch(() => {});
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[200] bg-navy-900 flex items-center justify-center" data-testid="intro-splash">
      <video
        ref={videoRef}
        src={src}
        autoPlay
        muted
        playsInline
        onEnded={dismiss}
        className="max-h-full max-w-full w-auto h-auto object-contain"
        data-testid="intro-splash-video"
      />
      <button
        onClick={toggleSound}
        aria-label={muted ? "Activer le son" : "Couper le son"}
        data-testid="intro-splash-sound"
        className="absolute bottom-6 left-6 w-11 h-11 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur text-white flex items-center justify-center transition-colors"
      >
        {muted ? <VolumeX size={20} /> : <Volume2 size={20} />}
      </button>
      <button
        onClick={dismiss}
        data-testid="intro-splash-skip"
        className="absolute top-6 right-6 inline-flex items-center gap-2 rounded-full bg-white/15 hover:bg-white/25 backdrop-blur text-white font-display font-semibold text-sm px-5 py-2.5 transition-colors"
      >
        Passer <X size={16} />
      </button>
    </div>
  );
};

export default IntroSplash;
